const menuComponentLoaders = Object.freeze({
  'menu.catalog-workspace': async () => {
    const module = await import('./menu-workspace-component.js');
    return module.MenuWorkspaceComponent;
  },
});

export default menuComponentLoaders;
